import React from 'react';

const TransactionIcon = ({ fill }) => {
  return (
    <svg
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M2.775 2.46548C2.475 2.16548 2.025 2.16548 1.725 2.46548C1.425 2.76548 1.425 3.21548 1.725 3.51548L5.7 7.49048H3C2.55 7.49048 2.25 7.79048 2.25 8.24048C2.25 8.69048 2.55 8.99048 3 8.99048H7.5C7.575 8.99048 7.725 8.99048 7.8 8.91548C7.95 8.84048 8.1 8.69048 8.175 8.54048C8.25 8.46548 8.25 8.31548 8.25 8.24048V3.74048C8.25 3.29048 7.95 2.99048 7.5 2.99048C7.05 2.99048 6.75 3.29048 6.75 3.74048V6.44048L2.775 2.46548ZM9.75 11.2405C9.75 11.1655 9.75 11.0155 9.825 10.9405C9.9 10.7905 10.05 10.6405 10.2 10.5655C10.275 10.4905 10.425 10.4905 10.5 10.4905H15C15.45 10.4905 15.75 10.7905 15.75 11.2405C15.75 11.6905 15.45 11.9905 15 11.9905H12.3L16.275 15.9655C16.575 16.2655 16.575 16.7155 16.275 17.0155C16.125 17.1655 15.975 17.2405 15.75 17.2405C15.525 17.2405 15.375 17.1655 15.225 17.0155L11.25 13.0405V15.7405C11.25 16.1905 10.95 16.4905 10.5 16.4905C10.05 16.4905 9.75 16.1905 9.75 15.7405V11.2405Z'
        fill='black'
      />
      <mask
        id='mask0'
        mask-type='alpha'
        maskUnits='userSpaceOnUse'
        x='1'
        y='2'
        width='16'
        height='16'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M2.775 2.46548C2.475 2.16548 2.025 2.16548 1.725 2.46548C1.425 2.76548 1.425 3.21548 1.725 3.51548L5.7 7.49048H3C2.55 7.49048 2.25 7.79048 2.25 8.24048C2.25 8.69048 2.55 8.99048 3 8.99048H7.5C7.575 8.99048 7.725 8.99048 7.8 8.91548C7.95 8.84048 8.1 8.69048 8.175 8.54048C8.25 8.46548 8.25 8.31548 8.25 8.24048V3.74048C8.25 3.29048 7.95 2.99048 7.5 2.99048C7.05 2.99048 6.75 3.29048 6.75 3.74048V6.44048L2.775 2.46548ZM9.75 11.2405C9.75 11.1655 9.75 11.0155 9.825 10.9405C9.9 10.7905 10.05 10.6405 10.2 10.5655C10.275 10.4905 10.425 10.4905 10.5 10.4905H15C15.45 10.4905 15.75 10.7905 15.75 11.2405C15.75 11.6905 15.45 11.9905 15 11.9905H12.3L16.275 15.9655C16.575 16.2655 16.575 16.7155 16.275 17.0155C16.125 17.1655 15.975 17.2405 15.75 17.2405C15.525 17.2405 15.375 17.1655 15.225 17.0155L11.25 13.0405V15.7405C11.25 16.1905 10.95 16.4905 10.5 16.4905C10.05 16.4905 9.75 16.1905 9.75 15.7405V11.2405Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0)'>
        <rect
          width='18'
          height='18'
          transform='matrix(-1 0 0 1 18 0.740479)'
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default TransactionIcon;
